import React from 'react';
import '../styles/AboutCO6.css'; 
import aboutco6 from '../assets/co6-aboutus.png'
import AnimatedArrowButton from './AnimatedArrowButton';

const AboutCO6 = () => {


    return(<div className='aboutco6'>
        <h4>About Us</h4>
        <hr></hr>
        <h2>Who are we?</h2>
        <p>Company Six Robotic Systems LLC (CO6) is a technology leader and provider of robotic automation systems. The company aims to integrate cutting-edge, disruptive technologies and design turnkey automation systems for enterprises and individuals.</p>
        <div className='aboutco6-container' style={{display:'flex', marginTop:'20px'}}>
            <div className='aboutco6-box1'>
                <img src={aboutco6} width='100%' height='100%' style={{objectFit:'contain'}}></img>
            </div>
            <div className='aboutco6-box2'>
            <h2>Our Mission</h2>
            <p>To empower industries with innovative robotic platforms and intelligent automation solutions that inspire collaboration, improve efficiency, and shape a sustainable future. Vision: “A world where humans and robots work together to redefine possibilities, transforming industries and enhancing lives.”</p>
            
            </div>
        </div>
    
    </div>);


}

export default AboutCO6;